import * as React from "react";

type Props = React.SVGProps<SVGSVGElement> & { color?: string };

const EditIcon = ({ color, className = "", ...props }: Props) => (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${color ? "" : "text-[#222] dark:text-nightTextSecondary"} ${className}`.trim()}
        {...props}
    >
        <path
            d="M7 6.99998H6C5.46957 6.99998 4.96086 7.2107 4.58579 7.58577C4.21071 7.96084 4 8.46955 4 8.99998V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H15C15.5304 20 16.0391 19.7893 16.4142 19.4142C16.7893 19.0391 17 18.5304 17 18V17M16 4.99998L19 7.99998M20.385 6.58499C20.7788 6.19114 21.0001 5.65697 21.0001 5.09998C21.0001 4.543 20.7788 4.00883 20.385 3.61498C19.9912 3.22114 19.457 2.99988 18.9 2.99988C18.343 2.99988 17.8088 3.22114 17.415 3.61498L9 12V15H12L20.385 6.58499Z"
            stroke={color || "currentColor"}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default EditIcon;
